import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, effect, inject, signal, viewChild } from '@angular/core';
import { RouterLinkActive, RouterModule } from '@angular/router';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';

// @ngrx/store
import { Store } from '@ngrx/store';
import * as fromAuth from '@app/auth/reducers';

import { environment } from '@env/environment';

@Component({
  selector: 'app-menu',
  imports: [CommonModule, RouterModule],
  templateUrl: './menu.component.html',
})
export class MenuComponent {
  // ? store - global
  #globalStore = inject(Store);

  // ? signals - view
  warehouseMenu$$ = viewChild<RouterLinkActive>('warehouseRla');
  customsMenu$$ = viewChild<RouterLinkActive>('customsRla');
  userMenu$$ = viewChild<RouterLinkActive>('userRla');

  // ? signals - states
  isCustomBroker$$ = toSignal(this.#globalStore.select(fromAuth.selectIsCustomBroker));
  warehouseMenuIsActive$$ = signal(false);
  customsMenuIsActive$$ = signal(false);
  userMenuIsActive$$ = signal(false);

  // ? states
  isE2e = environment.domain === 'e2e';
  expandedMenu: { warehouse: boolean | undefined; customs: boolean | undefined; user: boolean | undefined } = {
    warehouse: undefined,
    customs: undefined,
    user: undefined,
  };
  constructor(
    private cdr: ChangeDetectorRef,
    private destroyRef: DestroyRef,
  ) {
    effect(() => {
      const warehouseMenuComponent = this.warehouseMenu$$();
      if (warehouseMenuComponent) {
        warehouseMenuComponent.isActiveChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isActive) => {
          this.warehouseMenuIsActive$$.set(isActive);
        });
      }
    });
    effect(() => {
      const customsMenuComponent = this.customsMenu$$();
      if (customsMenuComponent) {
        customsMenuComponent.isActiveChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isActive) => {
          this.customsMenuIsActive$$.set(isActive);
        });
      }
    });
    effect(() => {
      const userMenuComponent = this.userMenu$$();
      if (userMenuComponent) {
        userMenuComponent.isActiveChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isActive) => {
          this.userMenuIsActive$$.set(isActive);
        });
      }
    });
  }

  //#region events
  toggleMenu(menu: keyof typeof this.expandedMenu) {
    if (menu === 'warehouse') {
      this.warehouseMenuIsActive$$.update((prev) => !prev);
    } else if (menu === 'customs') {
      this.customsMenuIsActive$$.update((prev) => !prev);
    } else if (menu === 'user') {
      this.userMenuIsActive$$.update((prev) => !prev);
    }
  }
  //#endregion

  //#region helper methods
  //#endregion
}
